import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.css';

export default function Home() {
  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <div className={styles.menu}>
          <Link to="/">Inicio</Link>
          <a href="#sobre">¿Qué es?</a>
          <a href="#servicios">Servicios</a>
                </div>
      </div>

      {/* Hero */}
      <div className={styles.hero}>
        <h1 className={styles.title}>Transformá tu cuerpo.</h1>
        <h2 className={styles.subtitle}>Evolucioná con CalisXcore.</h2>
        <p className={styles.description}>
          Consultoría personalizada, rutinas diseñadas para tu objetivo.  
          CalisXcore ofrece asesoramiento profesional exclusivo para quienes entrenan con intención.  
          Creamos planes de entrenamiento visuales e inteligentes, adaptados a tus metas reales.
        </p>

        <div className={styles.buttonGroup}>
          <Link to="/consulta-personalizada">
            <button className={styles.primaryBtn}>💬 Consulta privada ($35.38)</button>
          </Link>
        </div>
      </div>

      {/* ¿Qué es CalisXcore? */}
      <div id="sobre" className={styles.section}>
        <h2>¿Qué es CalisXcore?</h2>
        <p>
          CalisXcore es una consultoría visual e inteligente para quienes entrenan con propósito.  
          Diseñamos rutinas personalizadas según tu nivel, tus objetivos y tu estilo de vida.  
          A través de sesiones privadas, te guiamos con método, claridad y herramientas estratégicas para que logres resultados reales.  
          Ya sea que estés comenzando o buscando transformar tu físico, CalisXcore te acompaña con precisión y compromiso.
        </p>
      </div>

      {/* Sección motivacional */}
      <div className={styles.section}>
        <div className={styles.motivacionalBlock}>
          <div className={styles.motivacionalItem}>
            <img src="/imagenes/image1.jpg" alt="Disciplina" />
            <p>Disciplina</p>
          </div>
          <div className={styles.motivacionalItem}>
            <img src="/imagenes/image2.jpg" alt="Progresión" />
            <p>Progresión</p>
          </div>
          <div className={styles.motivacionalItem}>
            <img src="/imagenes/image3.jpg" alt="Fuerza real" />
            <p>Fuerza real</p>
          </div>
        </div>
      </div>

      {/* Beneficios */}
      <div className={styles.section}>
        <h2>Beneficios de entrenar con método</h2>
        <div className={styles.beneficioGrid}>
          <div className={styles.beneficioCard}>
            <h3>📋 Organización</h3>
            <p>Planificá tu rutina semanal con ejercicios bien definidos, objetivos claros y seguimiento visual.</p>
          </div>
          <div className={styles.beneficioCard}>
            <h3>📈 Progreso real</h3>
            <p>Usá indicadores, niveles y rutinas ajustadas para ver tu evolución física semana a semana.</p>
          </div>
          <div className={styles.beneficioCard}>
            <h3>🧠 Claridad mental</h3>
            <p>Entrenar con método te libera del caos. Te enfocás, cumples y avanzás.</p>
          </div>
        </div>
      </div>

      {/* Servicios / Roles */}
      <div id="servicios" className={styles.section}>
        <h2>Servicios disponibles</h2>
        <div className={styles.rolesGrid}>
          <div className={styles.rolCard}>
            <h3>💬 Consulta privada</h3>
            <p>
              Recibe asesoramiento personalizado en base a tus objetivos y horarios.  
              Ideal para quienes buscan una guía profesional adaptada a su realidad.  
              Incluye contacto directo y seguimiento.
            </p>
            <Link to="/consulta-personalizada">
              <button className={styles.primaryBtn}>Solicitar consulta ($35.38)</button>
            </Link>
          </div>
         
        </div>
      </div>

      {/* Footer */}
      <footer className={styles.footer}>
        CalisXcore © {new Date().getFullYear()} | Plataforma inteligente de entrenamiento físico
      </footer>
    </div>
  );
}
